import { z } from "zod";

export const subscriberFormSchema = z.object({
  email: z
    .string()
    .min(1, "email.required")
    .pipe(z.email("email.invalid")),
  active: z.boolean().default(true).optional(),
});

export type SubscriberFormData = z.infer<typeof subscriberFormSchema>;
